<template>
  <v-sheet width="412">
    <v-list-item>
      <v-list-item-avatar>
        <v-avatar size="40" color="primary">
          <v-img
            cover
            v-if="getPicture"
            width="40"
            height="40"
            :src="getPicture"
          />
          <span class="white--text" style="text-transform: uppercase;" v-else>
            {{ firstLetters }}
          </span>
        </v-avatar>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="headline font-weight-medium">
          <div class="caption-2" v-if="auth.user.value">
            {{ auth.user.value.login }}
          </div>
        </v-list-item-title>
        <v-list-item-subtitle>
          <div class="body-2 text--secondary" v-if="auth.user.value">
            {{ auth.user.value.mEmail }}
          </div>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-divider></v-divider>
    <v-list dense>
      <v-list-item
        v-for="item in items()"
        :disabled="item.disabled"
        :key="item.id"
        :data-test="item.id"
        @click="item.action(item)"
      >
        <v-list-item-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            {{ item.title }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-sheet>
</template>

<script>
import useAuth from '@/api/auth';
import provider from '@/api/apollo-client';
import hideIfEmpty from '@/utils/hideIfEmpty';

export default {
  name: 'MenuUser',
  methods: {
    logout() {
      this.auth.logout();
      this.$router.push({ name: 'login' });
      provider.clearStore();
    },
    items() {
      return [
        {
          id: 'edit_profile',
          title: 'Edit account',
          icon: 'mdi-pencil',
          action: () => {
            this.$emit('show-popup', 'userEdit');
          }
        },
        {
          id: 'program_settings',
          title: 'Program settings',
          icon: 'mdi-cog',
          action: () => {
            this.$emit('show-popup', 'programSettings');
          }
        },
        {
          id: 'menu_settings',
          title: 'Menu settings',
          icon: 'mdi-bookmark-box-multiple',
          action: () => {
            this.$emit('show-popup', 'menuSettings');
          }
        },
        ...hideIfEmpty(this.isShowInAppNotifications, [
          {
            id: 'notification_settings_in_app',
            title: 'Notification settings',
            icon: 'mdi-bell-plus',
            action: () => {
              this.$emit('show-popup', {
                name: 'notySettings',
                payload: this.isShowInAppNotifications
              });
            }
          }
        ]),
        ...hideIfEmpty(this.isShowSmsNotifications, [
          {
            id: 'notification_settings_sms',
            title: 'SMS (Twilio)',
            icon: 'mdi-message-alert',
            action: () => {
              this.$emit('show-popup', {
                name: 'notySettings',
                payload: this.isShowSmsNotifications
              });
            }
          }
        ]),
        ...hideIfEmpty(this.isShowWhatsAppNotifications, [
          {
            id: 'notification_settings_whatsap',
            title: 'WhatsApp (Twilio)',
            icon: 'mdi-whatsapp',
            action: () => {
              this.$emit('show-popup', {
                name: 'notySettings',
                payload: this.isShowWhatsAppNotifications
              });
            }
          }
        ]),
        ...hideIfEmpty(this.isShowEmailNotifications, [
          {
            id: 'notification_settings_email',
            title: 'E-mail notifications',
            icon: 'mdi-email',
            action: () => {
              this.$emit('show-popup', {
                name: 'notySettings',
                payload: this.isShowEmailNotifications
              });
            }
          }
        ]),
        ...hideIfEmpty(this.isShowTelegramNotifications, [
          {
            id: 'notification_settings_telegram',
            title: 'Telegram notifications',
            icon: 'mdi-send',
            action: () => {
              this.$emit('show-popup', {
                name: 'notySettings',
                payload: this.isShowTelegramNotifications
              });
            }
          }
        ]),
        {
          id: 'logout',
          title: 'Logout',
          icon: 'mdi-exit-to-app',
          action: () => {
            this.logout();
            provider.clearStore();
          }
        }
      ];
    }
  },
  mounted() {
    const notificationProfiles = this.auth.profile.value.objectsToObjectsByObject1Id.map(
      item => item.object2
    );
    console.log(notificationProfiles);
  },
  data() {
    return {
      auth: useAuth()
    };
  },
  computed: {
    notificationProfiles() {
      return this.auth.profile.value.objectsToObjectsByObject1Id.map(
        item => item.object2
      );
    },
    isShowEmailNotifications() {
      const channelIn = this.notificationProfiles.find(
        item => item.deliveryChannel === 'Email'
      );

      return channelIn;
    },

    isShowInAppNotifications() {
      const channelIn = this.notificationProfiles.find(
        item => item.deliveryChannel === 'In-app'
      );

      return channelIn;
    },
    isShowSmsNotifications() {
      const channelIn = this.notificationProfiles.find(
        item => item.deliveryChannel === 'SMS (Twilio)'
      );

      return channelIn;
    },
    isShowWhatsAppNotifications() {
      const channelIn = this.notificationProfiles.find(
        item => item.deliveryChannel === 'WhatsApp (Twilio)'
      );

      return channelIn;
    },
    isShowTelegramNotifications() {
      const channelIn = this.notificationProfiles.find(
        item => item.deliveryChannel === 'Telegram'
      );

      return channelIn;
    },
    getPicture() {
      if (this.auth.user.value?.mIcon) {
        return `${window.__pixelConfig.APP_MEDIA_SERVER}/download/${
          this.auth.user.value?.mIcon
        }/${localStorage.getItem('authToken')}`;
      } else {
        return '';
      }
    },
    firstLetters() {
      if (this.auth.user.value?.login) {
        const r = this.auth.user.value.login.split(' ');
        return r.length > 1 ? `${r[0][0]}${r[1][0]}` : `${r[0][0]}`;
      }
      return 'UN';
    }
  }
};
</script>
